<template>
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Password Reset</div>

                    <div class="card-body">
                        <form @submit.stop.prevent="onSubmit">
                            <messages :messages="messages"/>
                            <div class="container mt-2">
                                <template>
                                    <div class="row" v-if="!token_requested">
                                        <b-form-group
                                                      class="col-md-8"
                                                      label="Please enter your username to continue"
                                                      :label-for="getId('username')"
                                                      :state="fieldState('username')"
                                                      :invalid-feedback="invalidField('username')"
                                        >
                                            <b-form-input
                                                :id="getId('username')"
                                                type="text"
                                                v-model="username"
                                                :state="fieldState('username')"
                                                placeholder="Enter username">
                                            </b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="form-group row mb-0">
                                        <div class="col-md-8 mt-2 button-container">
                                            <template v-if="token_requested">
                                                <router-link to="/auth/request-password-reset" class="btn btn-primary">Enter SMS Code</router-link>
                                                <button type="submit" class="btn btn-primary" :disabled="loading">
                                                    Code not received - resend
                                                </button>
                                            </template>
                                            <button v-else type="submit" class="btn btn-primary" :disabled="loading">
                                                Reset Password
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {getExceptionErrorMessage, getHttpValidationErrors} from '../../util/common'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import axios from "axios";
export default {
    mixins: [BootstrapValidation],
    created(){
    },
    data() {
        return {
            messages: [],
            errors: [],
            password: null,
            username: '',
            token_requested: false,
            loading: false,
            confirm_code: false,
        }
    },
    computed: {
    },
    methods: {
        getId(name){
            return name;
        },
        async onSubmit(){
            this.loading = true
            this.messages = [];
            this.errors = [];
            try {
                let url = this.$laravelRoute('request-password-reset.post')
                let data = {
                    username: this.username,
                }
                let response = await axios.post(url, data);
                if(response && response.data){
                    this.messages.push({type: 'success', message: response.data.message});
                    this.errors = [];
                    this.token_requested = true
                } else {
                    this.messages.push({type: 'danger', message: 'Something went wrong, please try again.'});
                }
            } catch (error) {
                console.warn('onSubmit error: ', error);
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }
            }
            this.loading = false
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Auth/ForgotPassword.vue